import { inject, Injectable } from '@angular/core';
import { HttpInterceptorFn , HttpErrorResponse, HttpRequest, HttpHandlerFn, HttpEvent, HttpContextToken } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, delay, finalize } from 'rxjs/operators';
import { NgxToastrService } from '../_services/ngx-toastr/ngx-toastr.service';
import { LoadingService } from './loading.service';
import { Router } from '@angular/router';
import { SKIP_INTERCEPTOR } from '../services/loading.service';
import { LocalStorageService } from './local-storage.service';
import * as constants from '../../assets/config/constants.json';



export const httpErrorInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const alertService = inject(NgxToastrService);
  const loadingService = inject(LoadingService);
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);
  const ignoreErrorUrls: string[] = [
    constants.allUsers + "/permissions",
    constants.properties + "/cities",
    constants.properties + "/states"
  ];
  const shouldIgnore = ignoreErrorUrls.some(url => req.url.includes(url));  
  if(!shouldIgnore) loadingService.show();  
  // let withCredentials = true;
  // if (req.context.get(SKIP_INTERCEPTOR) == true) {      
  //     withCredentials = true;
  // }
  // console.log(withCredentials , req.context.get(SKIP_INTERCEPTOR));
  // console.log(req);

  const clonedRequest = req.clone({
    withCredentials: true
  });
  // const delayMs = 200;

  return next(clonedRequest).pipe(
    // delay(delayMs),
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unknown error occurred!';
      
      if (error.error instanceof ErrorEvent) {
        // Client-side error
        errorMessage = `Client Error: ${error.error.message}`;
      } else {
        // Server-side error
        errorMessage = `Server Error ${error.status}: ${error.message}`;
      }
      if(error.status == 401){
        localStorageService.clear();
        router.navigate(['/login']);
      }
      let error_msg =  error?.error?.message ? error.error.message  : "Something went wrong!";
      if(!shouldIgnore) alertService.error(error_msg , "toast-top-right");
      return throwError(() => new HttpErrorResponse({
        status: error.status,
        statusText: error.statusText,
        error: { message: errorMessage }
      }));
    }),
    finalize(() => {
      if(!shouldIgnore) loadingService.hide()
    })
  );
};
